import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { useFormatMessage, useIntl } from '@babylon/intl'
import {
  ModalContent,
  Icon,
  LinkAnchor,
  EditorialLayout,
  Text,
} from '@babylon/medkit'

import { trackTealiumEvent, trackTealiumView } from '@/tracking'
import { useSupportInfo } from '@/redux/productConfig/selectors'
import { useConfig, useLocalisedContent } from '@/redux/partnerConfig/selectors'
import messages from './messages'
import styles from './EligibilityModal.module.scss'

const trackEmailClick = () =>
  trackTealiumEvent({
    screen_title: 'signup/error/details-not-found',
    eventCategory: 'signup',
    eventAction: 'clicked email support',
    tealium_event: 'clicked email support',
  })

const trackPhoneClick = () =>
  trackTealiumEvent({
    screen_title: 'signup/error/details-not-found',
    eventCategory: 'signup',
    eventAction: 'clicked phone number support',
    tealium_event: 'clicked phone number support',
  })

const EligibilityModal = () => {
  const translate = useFormatMessage()
  const { locale } = useIntl()
  const { email, phone } = useSupportInfo()
  const { name } = useConfig()
  const { eligibilityModalConfig } = useLocalisedContent(locale)

  const modalTitle = eligibilityModalConfig?.title || translate(messages.title)
  const modalHideSupportInfo = !!eligibilityModalConfig?.hideSupportInfo

  useEffect(() => {
    trackTealiumView({
      screen_title: 'signup/error/details-not-found',
      tealium_event: 'signup/error/details-not-found',
    })
    // eslint-disable-next-line
  }, [])

  return (
    <ModalContent title={modalTitle}>
      <EditorialLayout>
        {eligibilityModalConfig?.description ? (
          eligibilityModalConfig?.description?.map((copy, index) => (
            <Text
              variant="body"
              key={index}
              data-testid="eligibilityModalContent"
              dangerouslySetInnerHTML={{
                __html: copy,
              }}
            />
          ))
        ) : (
          <Text variant="body" data-testid="eligibilityModalContent">
            <FormattedMessage {...messages.description} values={{ name }} />
          </Text>
        )}

        {!modalHideSupportInfo && (
          <>
            <div className={styles.infoRow} data-testid="supportEmail">
              <Icon
                className={styles.infoIcon}
                fill="--medkit-icon-fill"
                height={24}
                icon="EmailFilled"
                title="Email Icon"
                width={24}
              />
              <LinkAnchor
                href={`mailto:${email}`}
                onClick={() => trackEmailClick()}
              >
                {email}
              </LinkAnchor>
            </div>
            <div className={styles.infoRow} data-testid="supportPhoneNumber">
              <Icon
                className={styles.infoIcon}
                fill="--medkit-icon-fill"
                height={24}
                icon="PhoneFilled"
                title="Phone Icon"
                width={24}
              />
              <LinkAnchor
                href={`tel:${phone}`}
                onClick={() => trackPhoneClick()}
              >
                {phone}
              </LinkAnchor>
            </div>
          </>
        )}
      </EditorialLayout>
    </ModalContent>
  )
}

export default EligibilityModal
